import { __decorate } from 'tslib';
import { EventEmitter, ViewChild, Input, Output, Component, NgModule } from '@angular/core';
import { Base64Service } from '@wlp/ui-bs-util';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { UiCHeaderModule } from '@wlp/ui-c-header';
import { UiCButtonModule } from '@wlp/ui-c-button';
import { FormsModule } from '@angular/forms';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';

let UiCUploadFileWebComponent = class UiCUploadFileWebComponent {
    constructor(base64Service) {
        this.base64Service = base64Service;
        this.sizeFile = 5242880;
        this.getFile = new EventEmitter();
        this.goBackFile = new EventEmitter();
        this.goRemoveFile = new EventEmitter();
        this.ownership = new EventEmitter();
        this.burst = new EventEmitter();
    }
    uploadFile(fileList) {
        this.fileSelected = fileList.item(0);
        if (this.fileSelected.size > this.sizeFile) {
            this.removeFile();
            this.burst.emit();
            return;
        }
        this.base64Service
            .convertFileToBase64(this.fileSelected)
            .then((data) => {
            this.base64 = { photo: data };
            this.sendBase64(this.base64);
        })
            .catch((err) => {
            console.error('Erro no converte', err);
        });
    }
    goBack() {
        this.goBackFile.emit();
    }
    removeFile() {
        this.file = null;
        this.fileSelected = null;
        this.goRemoveFile.emit();
    }
    continue() {
        this.sendBase64(this.base64);
    }
    sendBase64(base64) {
        const file = { file: this.fileSelected, base64: base64 };
        this.getFile.emit(file);
    }
    isOwnership(value) {
        const file = { isOwnership: value };
        this.ownership.emit(file);
    }
};
UiCUploadFileWebComponent.ctorParameters = () => [
    { type: Base64Service }
];
__decorate([
    ViewChild('fileInput', { static: true })
], UiCUploadFileWebComponent.prototype, "fileInput", void 0);
__decorate([
    Input()
], UiCUploadFileWebComponent.prototype, "uploadType", void 0);
__decorate([
    Input()
], UiCUploadFileWebComponent.prototype, "sizeFile", void 0);
__decorate([
    Input()
], UiCUploadFileWebComponent.prototype, "subTitle", void 0);
__decorate([
    Output()
], UiCUploadFileWebComponent.prototype, "getFile", void 0);
__decorate([
    Output()
], UiCUploadFileWebComponent.prototype, "goBackFile", void 0);
__decorate([
    Output()
], UiCUploadFileWebComponent.prototype, "goRemoveFile", void 0);
__decorate([
    Output()
], UiCUploadFileWebComponent.prototype, "ownership", void 0);
__decorate([
    Output()
], UiCUploadFileWebComponent.prototype, "burst", void 0);
UiCUploadFileWebComponent = __decorate([
    Component({
        selector: 'ui-c-upload-file-web',
        template: "<ion-row *ngIf=\"!fileSelected\">\n  <div class=\"box-radius border w100\">\n    <ion-row>\n      <ion-col size=\"12\">\n        <ion-row>\n          <ion-col size=\"12\" size-lg=\"6\">\n            <ion-img class=\"ion-padding\" [src]=\"'assets/images/sign-up/upload-document/upload-document.svg'\"> </ion-img>\n          </ion-col>\n          <ion-col size=\"12\" size-lg=\"6\" class=\"ion-padding\">\n            <ion-text class=\"ion-text-start\">\n              <h2 class=\"font-family-bold\">{{ 'ONBORDING.UPLOAD_DOCUMENTS_WEB.TITLE' | wlpTranslate }}</h2>\n              <p>{{ subTitle | wlpTranslate }}</p>\n            </ion-text>\n            <!--                <ui-c-button expand=\"block\" (click)=\"uploadFile()\">Enviar</ui-c-button>-->\n            <div class=\"input-div\">\n              <input\n                type=\"file\"\n                #fileInput\n                [(ngModel)]=\"file\"\n                (change)=\"uploadFile($event.target.files)\"\n                class=\"custom-file-input\"\n              />\n              <span class=\"file-custom\"></span>\n            </div>\n          </ion-col>\n        </ion-row>\n      </ion-col>\n    </ion-row>\n  </div>\n</ion-row>\n\n<ion-row *ngIf=\"fileSelected\">\n  <div class=\"box-radius border w100\">\n    <ion-row class=\"ion-justify-content-center\">\n      <ion-col size=\"6\">\n        <ion-item lines=\"none\" class=\"img-content\" size=\"3\">\n          <!-- <ion-img class=\"w100 ion-padding\" [src]=\"'assets/images/sign-up/upload-document/jpg-image.svg'\"\n            *ngIf=\"uploadType\"></ion-img>\n          <ion-img class=\"w100 ion-padding\" [src]=\"'assets/images/sign-up/upload-document/pdf-image.svg'\"\n            *ngIf=\"!uploadType\"></ion-img> -->\n          <ion-img\n            class=\"w100 ion-padding\"\n            [src]=\"'assets/images/sign-up/upload-document/concluido-upload.svg'\"\n          ></ion-img>\n        </ion-item>\n      </ion-col>\n    </ion-row>\n\n    <ion-row>\n      <ion-col size=\"12\" class=\"ion-text-center\">\n        <!--          <ion-text class=\"text-action\" (click)=\"removeFile()\">-->\n        <!--            <p class=\"ion-no-margin ion-margin-bottom\">Excluir</p>-->\n        <!--          </ion-text>-->\n        <ui-c-button mode=\"text\" (continue)=\"removeFile()\">\n          <span class=\"title\">{{ 'ONBORDING.UPLOAD_DOCUMENTS_WEB.EXCLUDE_BUTTON' | wlpTranslate }}</span>\n        </ui-c-button>\n      </ion-col>\n    </ion-row>\n  </div>\n\n  <ion-col size=\"12\" *ngIf=\"uploadType\">\n    <div class=\"detail-item\">\n      <ion-list>\n        <ion-item>\n          <ion-label>{{ 'ONBORDING.UPLOAD_DOCUMENTS_WEB.OWNERSHIP_SELECT.LABEL' | wlpTranslate }}</ion-label>\n          <ion-select (ionChange)=\"isOwnership($event.target.value)\">\n            <ion-select-option value=\"OWNERAOFTHECCOUNT\">{{\n              'ONBORDING.UPLOAD_DOCUMENTS_WEB.OWNERSHIP_SELECT.OWNERAOFTHECCOUNT' | wlpTranslate\n            }}</ion-select-option>\n            <ion-select-option value=\"SPOUSE\">{{\n              'ONBORDING.UPLOAD_DOCUMENTS_WEB.OWNERSHIP_SELECT.SPOUSE' | wlpTranslate\n            }}</ion-select-option>\n            <ion-select-option value=\"FATHERORMOTHER\">{{\n              'ONBORDING.UPLOAD_DOCUMENTS_WEB.OWNERSHIP_SELECT.FATHERORMOTHER' | wlpTranslate\n            }}</ion-select-option>\n            <ion-select-option value=\"BROTHERORSISTER\">{{\n              'ONBORDING.UPLOAD_DOCUMENTS_WEB.OWNERSHIP_SELECT.BROTHERORSISTER' | wlpTranslate\n            }}</ion-select-option>\n          </ion-select>\n        </ion-item>\n      </ion-list>\n    </div>\n  </ion-col>\n</ion-row>\n\n<!--    <div class=\"group-buttons\" *ngIf=\"fileSelected\">-->\n<!--      <div class=\"container\">-->\n<!--        <ion-row class=\"ion-justify-content-center\">-->\n<!--          <ion-col size=\"12\" class=\"ion-padding\">-->\n<!--            <ui-c-button expand=\"block\" (continue)=\"continue()\">-->\n<!--              <span class=\"title\">Continuar</span>-->\n<!--            </ui-c-button>-->\n<!--          </ion-col>-->\n<!--        </ion-row>-->\n<!--      </div>-->\n<!--    </div>-->\n",
        styles: [""]
    })
], UiCUploadFileWebComponent);

let UiCUploadFileWebModule = class UiCUploadFileWebModule {
};
UiCUploadFileWebModule = __decorate([
    NgModule({
        declarations: [UiCUploadFileWebComponent],
        imports: [
            CommonModule,
            IonicModule,
            UiCHeaderModule,
            UiCButtonModule,
            FormsModule,
            UiBsTranslateModule
        ],
        exports: [UiCUploadFileWebComponent]
    })
], UiCUploadFileWebModule);

/*
 * Public API Surface of ui-c-upload-file
 */

/**
 * Generated bundle index. Do not edit.
 */

export { UiCUploadFileWebComponent, UiCUploadFileWebModule };
//# sourceMappingURL=wlp-ui-c-upload-file-web.js.map
